<template>
    <b-card v-if="!loadingPage" class="pt-2">
        <b-row>
            <b-col md="3" class="d-flex align-items-center justify-content-center mb-2">
                <div class="d-flex align-items-center">
                    <b-form-radio v-for="(subscription, index) in subscriptionList" :key="index" class="mr-2"
                        v-model="form.subscriptionId" name="some-radios" :value="subscription.id">
                        {{ subscription.title }}
                    </b-form-radio>
                </div>
            </b-col>
            <b-col md="3" class="mb-2">
                <b-form-input class="text-center" v-model="form.totalDays" placeholder="مدت زمان اشتراک" dir="ltr" />
            </b-col>
            <b-col md="3" class="mb-2">
                <b-form-input class="text-center" v-model="form.phoneNumber" placeholder="شماره همراه مدیر" dir="ltr" />
            </b-col>
            <b-col md="3" class="mb-2">
                <b-button @click="createStore" variant="primary" class="w-100" :disabled="loading">
                    ایجاد مجموعه
                </b-button>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BFormInput, BFormRadio } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BFormInput,
        BFormRadio
    },
    data() {
        return {
            loadingPage: true,
            loading: false,
            subscriptionList: [],
            form: {
                totalDays: null,
                subscriptionId: null,
                phoneNumber: null,
            },
        };
    },
    methods: {
        async getSubscriptionList() {
            this.loadingPage = true
            await this.$axios.get('/Subscription').then((data) => {
                this.subscriptionList = data.data.subscriptions
                this.loadingPage = false
            })
        },
        createStore() {
            this.loading = true
            adminService.createStore(this.form).then(({ data }) => {
                this.form.totalDays = null;
                this.form.subscriptionId = null;
                this.form.phoneNumber = null;
                this.$notif({ type: 'success' });
                this.loading = false
            })
                .catch(() => {
                    this.loading = false
                });
        }
    },
    mounted() {
        this.getSubscriptionList()
    },
};
</script>
